import Index from '../../pages/snail/webcast/index'
import Help from '../../pages/snail/webcast/help'

const base = 'webcast'

const routes = [
    {
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    },
    {
        path: `/${base}/help*`,
        name: `${base}-help`,
        component: Help
    }

]

export default routes



// WEBPACK FOOTER //
// ./src/router/snail/webcast.js